import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Checkbox, Table, Input, Button, ConfigProvider, Empty } from 'antd';
import * as _ from 'lodash';

const TemplateBrowser = (
  {
    wrapRef,
		workingFolder,
		onDoubleClick,
		onTemplateSelect,
		selectedRowKeys,
		templatesRetricted,
		templates,
		hasTemplates,
    onTemplateToggle,
    loadingTemplates
	}) => {

  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [ showAllTemplates, setShowAllTemplates ] = useState(false);
  
  useEffect(() => {

		setFilteredTemplates(templates);

  }, [templates, setFilteredTemplates])

  let searchInput = null;

  const handleSearch = (dataIndex, selectedKeys, confirm) => {
    confirm();
  };

  const handleReset = (clearFilters, confirm) => {
    setFilteredTemplates(templates);
    clearFilters();
    confirm();
  };

  const getColumnSearchProps = (columnTitle, dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput = node;
          }}
          placeholder={`Filter ${columnTitle}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(dataIndex, selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(dataIndex, selectedKeys, confirm)}
          style={{ width: 90, marginRight: 8 }}
        >
          Apply
        </Button>
        <Button onClick={() => handleReset(clearFilters, confirm)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    }
  });
  
  const handleTableChange = (pagination, filters, sorter) => {

    if(filters.name) {
      const escapeRegExp = (str) =>
        str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape special regex characters
      
      const safePattern = `^${escapeRegExp(filters.name[0])}`;
      const regExp = new RegExp(safePattern, 'i');

      const filteredTemplates = _.filter(templates, template => regExp.test(template.name));

      setFilteredTemplates(filteredTemplates);
    }
    else {
      setFilteredTemplates(templates);
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      filterSearch: true,
      ellipsis: true,
      ...getColumnSearchProps('Name', 'name'),
      render: (text, item) => <a>
                                <div className={`file-icon-small files-small-${item.type}`} style={{ marginRight: '10px', marginTop: '2px'}}></div>
                                {`${item.name}${item.type ? '.' + item.type : ''}`}
                              </a>,
    },
    {
      title: 'Path',
      dataIndex: 'path',
      key: 'path',
      ellipsis: true
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true
    }
  ];
  
  const selectDocument = record => {
    onTemplateSelect(record)
  }
  
  const onChange = ({target}) => {
    setShowAllTemplates(target.checked);
    onTemplateToggle(target.checked);
  }

  return (
    <Container wrapRef={wrapRef} templates={templates}>
      <BreadcrumbContainer>
        {!templatesRetricted &&
          <Checkbox
            disabled={!hasTemplates}
            checked={showAllTemplates || !hasTemplates}
            onChange={onChange}
            style={{ paddingLeft: '10px', marginTop: '2px' }}
          >
            Show all templates
          </Checkbox>
        }
        {templatesRetricted &&
          <div style={{marginLeft: '15px', color: 'var(--warning-color)' }}>Templates are restricted for this folder</div>
        }
      </BreadcrumbContainer>
      <Table
        loading={loadingTemplates}
        rowKey="id"
        size="small"
        tableLayout="fixed"
        scroll={{scrollToFirstRowOnChange: true, y: 1500}}
        columns={columns}
        dataSource={filteredTemplates}
        pagination={false}
        onChange={handleTableChange}
        locale={{
          emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={templatesRetricted && templates.length === 0 ? "This folder is marked as restricted but has no pre-assigned templates" : "No templates found"}
                      />
        }}
        rowSelection={{
          hideSelectAll: true,
          selectedRowKeys: selectedRowKeys
        }}
        onRow={(record) => ({
          onClick: () => selectDocument(record),
          onDoubleClick: () => onDoubleClick(record)
        })}
      />
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  table {
    height: ${p => p.templates.length === 0 ? '100%' : 'auto'};
  }
  .ant-table-body {
    overflow: auto;
    height: ${p => (p.wrapRef.current?.offsetHeight - 130) + "px" };
    .ant-table-row {
      cursor: pointer;
    }
  }
`

const BreadcrumbContainer = styled.div`
  width: 100%;
  height: 50px;
  line-height: 50px;
  .ant-table-body {
    overflow: auto;
  }
`

export default TemplateBrowser;